import { render } from "./Spinner.vue?vue&type=template&id=4236f52d&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=4236f52d&scoped=true&lang=css"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4236f52d"]])

export default __exports__